

<template>
    <div id="app" v-on:click="playClick" :class="{mobile: isMobile, 'auth-ambient': ambientAuth}" :style="[lightTheme ? cssVarsLight : cssVars, authStyle]" >
        <div class="blur-container" :class="{blur: blur}">
            <Header/>
            <div class="main">
                <SideMenu/>
                <Menu :class="{hide: !isMobile}"/>
                <MenuModal/>
                <div class="bigPane">
                    <Grid/>
                    <OrdersPane/>
                    <StatusBar/>
                </div>
            </div>
            <Footer/>
        </div>
        <AuthShell v-if="ambientAuth"/>
        <LoginModal/>
        <NoLandscape/>
        <ProfitCalculatorModal/>
        <AssetsInfoModal/>
        <RegisterModal/>
        <AccountModal/>
        <SymbolsModal/>
        <BalanceModal/>
        <AccountModal/>
        <GridsModal/>
        <NoConnectionModal/>
        <AutoCloseModal/>
        <PendingModal/>
        <Notifications/>
        <ForgotPasswordModal/>
        <NewPasswordModal/>
        <ClosePositionModal/>
        <GreetingModal/>
        <WithdrawalPolicyModal/>
        <DepositSuccessModal/>
        <DepositFailModal/>
        <WithdrawalCancelModal/>
        <DepositCancelModal/>
        <Fullscreen/>
        <TermsAndConditionModal v-if="brand === 'marketpulseinvest'"/>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {MODAL} from "@/store/mutations.type"
import {APP_INIT, PLAY_CLICK, LOGOUT} from '@/store/actions.type'
import {isMobile} from '@/common/helpers'

import AuthShell from "@/components/Auth/AuthShell"
import {authTokenOverrides} from "@/common/auth-theme"
import "@/assets/css/auth-ambient.css"

import Header from "@/components/Header"
import Footer from "@/components/Footer"
import SideMenu from "@/components/SideMenu"
import NoLandscape from "@/components/Modals/NoLandscape"
import SymbolsModal from "@/components/Modals/SymbolsModal"
import ProfitCalculatorModal from "@/components/Modals/ProfitCalculatorModal"
import AssetsInfoModal from "@/components/Modals/AssetsInfoModal"
import BalanceModal from "@/components/Modals/BalanceModal"
import LoginModal from "@/components/Modals/LoginModal"
import GridsModal from "@/components/Modals/GridsModal"
import AccountModal from "@/components/Modals/AccountModal"
import Notifications from "@/components/Notifications"
import RegisterModal from "@/components/Modals/RegisterModal"
import NoConnectionModal from '@/components/Modals/NoConnectionModal'
import MenuModal from '@/components/Modals/MenuModal'
import Menu from '@/components/Modals/HamburgerMenu'
import AutoCloseModal from '@/components/Modals/AutoCloseModal'
import PendingModal from '@/components/Modals/PendingModal'
import ForgotPasswordModal from '@/components/Modals/ForgotPasswordModal'
import NewPasswordModal from '@/components/Modals/NewPasswordModal'
import ClosePositionModal from '@/components/Modals/ClosePositionModal'
import GreetingModal from '@/components/Modals/GreetingModal'
import WithdrawalPolicyModal from '@/components/Modals/WithdrawalPolicyModal'
import DepositSuccessModal from '@/components/Modals/DepositSuccessModal'
import DepositFailModal from '@/components/Modals/DepositFailModal'
import WithdrawalCancelModal from '@/components/Modals/WithdrawalCancelModal'
import DepositCancelModal from '@/components/Modals/DepositCancelModal'
import Grid from '@/components/Grid'
import OrdersPane from "@/components/OrdersPane"
import StatusBar from "@/components/StatusBar"
import Fullscreen from "@/components/Modals/Fullscreen"

import {
    COLOR_FONT,
    COLOR_BG_FOOTER,
    COLOR_BG_DARK,
    COLOR_BG_DARK_MID,
    COLOR_BG,
    COLOR_BG_LIGHT,
    COLOR_WHITE,
    COLOR_BRAND,
    COLOR_GREEN,
    COLOR_GREEN_BUTTON,
    COLOR_RED,
    COLOR_PRIMARY_BUTTON,
    COLOR_SECONDARY_BUTTON,
    COLOR_BORDER,
    COLOR_MARKET_WATCH_TITLE, COLOR_BG_ASSETS_INFO, SHOW_TERMS, BRAND, AUTO_LOGOUT, AUTH_DESIGN
} from "@/common/config"
import TermsAndConditionModal from "@/components/Modals/TermsAndConditionModal"
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import {SET_BOT_DETECT} from "./store/mutations.type";

export default {
    name: 'App',
    components: {
        AuthShell,
        TermsAndConditionModal,
        StatusBar,
        OrdersPane,
        Grid,
        PendingModal,
        AutoCloseModal,
        MenuModal,
        Menu,
        AssetsInfoModal,
        NoConnectionModal,
        NoLandscape,
        ProfitCalculatorModal,
        RegisterModal,
        Notifications,
        AccountModal,
        GridsModal,
        LoginModal,
        BalanceModal,
        ForgotPasswordModal,
        NewPasswordModal,
        ClosePositionModal,
        GreetingModal,
        WithdrawalPolicyModal,
        DepositSuccessModal,
        DepositFailModal,
        WithdrawalCancelModal,
        DepositCancelModal,
        SymbolsModal, SideMenu, Footer, Header,
        Fullscreen
    },
    async mounted() {
        this.$store.dispatch(APP_INIT)
        if (isMobile()) {
            this.$store.commit(MODAL, {
                menu: false,
                sideMenu: false
            })
        }

        console.log("Hello World")

        const fp = await FingerprintJS.load();
        const result = await fp.get();

        const visitorId = result.visitorId;

        console.log('vis', visitorId)

        window.onresize = () => {
            window.scrollTo(0, document.body.scrollHeight)

            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`)
        }

        this.$store.commit(SET_BOT_DETECT, visitorId)

        // screen.orientation.lock('landscape')

        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`)

        if(AUTO_LOGOUT){
            localStorage.setItem('cfdLastInteraction', Date.now())
            this.autoLogout(AUTO_LOGOUT)
            document.addEventListener('mousedown', () => {
                this.autoLogout(AUTO_LOGOUT)
                localStorage.setItem('cfdLastInteraction', Date.now())
            })
    
            document.addEventListener('visibilitychange', () => {
                this.autoLogout(AUTO_LOGOUT)
            })
        }

    },
    data() {
        return {
            sessionStateInit: false,
            isMobile: isMobile(),
            cssVars: {
                '--font': COLOR_FONT,
                '--background-footer': COLOR_BG_FOOTER,
                '--background-dark': COLOR_BG_DARK,
                '--background-dark-mid': COLOR_BG_DARK_MID,
                '--background': COLOR_BG,
                '--background-light': COLOR_BG_LIGHT,
                '--white': COLOR_WHITE,
                '--brand': COLOR_BRAND,
                '--green': COLOR_GREEN,
                '--green-button': COLOR_GREEN_BUTTON,
                '--red': COLOR_RED,
                '--primary-button': COLOR_PRIMARY_BUTTON,
                '--secondary-button': COLOR_SECONDARY_BUTTON,
                '--border': COLOR_BORDER,
                '--market-watch-title': COLOR_MARKET_WATCH_TITLE,
                '--assets-info-gradient': COLOR_BG_ASSETS_INFO
            },
            cssVarsLight: {
                '--font': '#313131',
                '--background-footer': '#fff',
                '--background-dark': '#fff',
                '--background-dark-mid': '#f2f2f2',
                '--background': '#f2f2f2',
                '--background-light': '#f2f2f2',
                '--brand': COLOR_BRAND,
                '--border': '#E8F2F9',
                '--fs-border': '#E8F2F9',
                '--white-to-black': '#000',
                '--assets-info-gradient': 'linear-gradient(0deg, rgba(245, 255, 245, 1) 0%, rgba(245, 255, 245, .7) 45%, rgba(24, 31, 45, 0.45) 100%)',
            },
            showTerms: SHOW_TERMS,
            brand: BRAND,
            logoutTimeoutId: null,

        }
    },
    methods: {
        playClick() {
            this.$store.dispatch(PLAY_CLICK)
        },
        autoLogout(envLogoOut) {
            if (!envLogoOut) {
                return;
            }

            let lastInteraction = Number(window.localStorage.getItem('cfdLastInteraction') || 0);
            let timer = (Number(envLogoOut) >= 5 ? Number(envLogoOut) : 30) * 60 * 1000;

            if (lastInteraction + timer < Date.now()) {
                this.logout();
                return;
            }

            if (this.logoutTimeoutId) {
                clearTimeout(this.logoutTimeoutId);
            }

            this.logoutTimeoutId = setTimeout(() => {
                let lastInteraction = Number(window.localStorage.getItem('cfdLastInteraction') || 0);

                if (lastInteraction + timer < Date.now()) {
                    this.logout();
                    return;
                }

                this.autoLogout(envLogoOut);
            }, timer)
        },
        logout() {
            this.$store.dispatch(LOGOUT)
        },
    },
    computed: {
        ...mapGetters(['blur', 'symbols', 'sessionsState','termsIsAccept','lightTheme','loggedIn']),
        ambientAuth() {
            return AUTH_DESIGN === 'ambient' && !this.loggedIn
        },
        authStyle() {
            return this.ambientAuth ? authTokenOverrides() : {}
        },
    },
    // watch: {
    //     symbols() {
    //         if (!this.sessionStateInit) {
    //             this.$store.commit(SET_SESSION_TIME, this.symbols)
    //             this.sessionStateInit = true
    //         }
    //     }
    // }
}
</script>

<style>

:root {
    --background-footer: #18202d;
    --background-dark: #181f2d;
    --background-dark-mid: #252c3b;
    --background: #374054;
    --background-light: #363f52;
    --white: #ffffff;
    --white-to-black: #ffffff;
    --whitesmoke-to-lightgrey:#E5E6ED;
    --font: #8c8f96;
    --brand: #ff7600;
    --green: #31cf5a;
    --green-button: #2bab40;
    --red: #dd4931;
    --primary-button: #ff7600;
    --secondary-button: #424a5e;
    --border: #353c4e;

    --fs: #0F111D;
    --fs-border: #FFFFFF4C;
    --fs-th: #1E213A7F;
    --fs-tr: #202542;

    --background-active: #171721;
    --hover-color: #e3e3e3;

    --new-chat-color: #252c3b;
    --new-chat-bg:#181F2D ;
    --border-blue: #0D99FF;
}

body.light-theme{
    --background-footer: #fff;
    --background-dark:#fff;
    --background-dark-mid: var(--background-active);
    --background: #f2f2f2;
    --background-light: #f2f2f2;
    --white-to-black: #000;
    --whitesmoke-to-lightgrey:#26272b;
    --font: #313131;
    --brand: #ff7600;
    --border: #E8F2F9;

    --background-active: #fbfbfb;

    --hover-color: #fafbfd;
    --new-chat-color: #f8fbfd;
    --new-chat-bg:var(--background-active);
}

html, body, #app {
    position: fixed;
    height: 100%;
    width: 100%;
    min-width: 100%;
    min-height: 100%;
    margin: 0;
    padding: 0;
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 12px;
    font-weight: 100;
    background: var(--background-dark);
    color: var(--font);
}

[hidden] {
    display: none !important;
}

*, *:before, *:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    -webkit-touch-callout: none;
    -webkit-user-select: text;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    /* scrollbar-color: rgba(255, 255, 255, 0.05) rgba(255, 255, 255, 0.05);
    scrollbar-width: thin; */
}

*:focus {
    outline: none !important;
    caret-color: var(--white-to-black);
}

::placeholder {
    color: var(--secondary-button)
}

::-webkit-scrollbar {
    width: 1px;
    height: 1px;
}

::-webkit-scrollbar-track {
    background: var(--background-dark);
}

::-webkit-scrollbar-thumb, ::-webkit-scrollbar-thumb:hover {
    background: var(--brand);
}

::-webkit-scrollbar-corner {
    background: rgba(0, 0, 0, 0);
}

.noscroll::-webkit-scrollbar {
    width: 0;
    height: 0;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

#app {
    display: flex;
    flex-direction: column;
    position: relative;
    overflow-y: scroll;
}

.blur-container {
    display: flex;
    flex-direction: column;
    position: relative;
    background-size: cover;
    flex: 1 1 auto;
    overflow: hidden;
}

.hide {
    display: none !important;
}

.green {
    color: var(--green) !important;
}

.red {
    color: var(--red) !important;
}

.brand {
    color: var(--brand) !important;
}

.white {
    color: var(--white) !important;
}

.green-button {
    color: var(--white);
    background-color: var(--green-button)
}

.brand-button {
    color: var(--white);
    background-color: var(--brand)
}

.row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.show-hide-password {
    position: relative;
    width: 100%;
}

.show-hide-password i {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(-50%, -50%);
    cursor: pointer;
    font-size: 18px;
}

.show-hide-password input {
    max-width: 100%;
}

.newDesign .show-hide-password {
    background: rgba(180, 180, 180, 0.3);
    border-radius: 5px;
}

.newDesign .show-hide-password input {
    background: transparent;
}

.show-hide-password {
    background: var(--background);
    border-radius: 5px;
}

.show-hide-password input {
    padding: 8px 35px 8px 12px;
}

.stretch {
    align-items: stretch;
}

.flex-start {
    align-items: flex-start;
}

.col {
    display: flex;
    flex-direction: column;
}

.grid {
    display: flex;
    flex: 1 1 auto
}

.justify-end {
    justify-content: flex-end;
}

.align-end {
    align-items: flex-end;
}

.modal-wrapper {
    position: absolute;
    z-index: 1080 !important;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.modal {
    width: 300px;
    display: flex;
    background: var(--background-dark);
    border-radius: 3px;
}

.scroll {
    overflow-y: scroll;
    position: relative;
}

.shadow:after {
    content: '';
    position: absolute;
    z-index: 2;
    height: 30px;
    width: 100%;
    -webkit-box-shadow: inset 0 -20px 20px 0 var(--background-dark);
    -moz-box-shadow: inset 0 -20px 20px 0 var(--background-dark);
    box-shadow: inset 0 -20px 20px 0 var(--background-dark);
    bottom: 0;
    left: 0;
}

.overflow-hidden {
    overflow: hidden;
}

input {
    color: var(--white-to-black);
    -webkit-touch-callout: initial !important;
    -webkit-user-select: initial !important;
    -moz-user-select: initial !important;
    -ms-user-select: initial !important;
    user-select: initial !important;
}

select {
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: linear-gradient(45deg, transparent 50%, var(--white-to-black) 50%),
    linear-gradient(135deg, var(--white-to-black) 50%, transparent 50%);
    background-position: calc(100% - 0.75rem - 5px) 1em,
    calc(100% - 0.75rem) 1em;
    background-size: 5px 5px,
    5px 5px,
    1px 1.5em;
    background-repeat: no-repeat;
}

button {
    border: 1px solid var(--background);
    background: var(--background-light);
    border-radius: 3px;
    color: var(--white);
    cursor: pointer;
    padding: 8px 12px;
}

.form-icon {
    position: relative;
}

.form-control.form-image {
    padding: 8px 12px 8px 30px;
}

.form-icon img {
    width: 16px;
    height: 16px;
    object-fit: cover;
    position: absolute;
    top: 28px;
    left: 10px;
}

.form-icon .country {
    position: absolute;
    top: 31px;
    left: 10px;
}

.form-icon i {
    position: absolute;
    top: 28px;
    right: 10px;
    color: var(--white-to-black);
    cursor: pointer;
    font-size: 16px;
}

.form-control.phone {
    padding: 8px 12px 8px 30px;
}

.form-icon .select {
    font-size: 30px;
    top: 20px;
    right: 5px;
}

.phone-flag {
    position: absolute;
    left: 10px;
}

.form-icon label {
    margin-bottom: 5px;
    color: var(--white-to-black);
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    display: inline-block;
}

.form-icon input {
    width: 100%;
    background: rgba(180, 180, 180, 0.3);
    border-radius: 5px;
    color: var(--white-to-black);
}

label {
    font-size: 1em;
    font-weight: 400;
    margin-bottom: 0.5em;
}

.form-control {
    color: var(--white-to-black);
    border: 0;
    padding: 8px 12px;
    cursor: pointer;
    background: var(--background);
}

.form-control::placeholder {
    color: var(--font);
    opacity: 0.5;
}

.form-title {
    color: var(--white-to-black);
    font-weight: 600;
    font-size: 12px;
}

.fullscreen-page-title {
    font-weight: 700;
    font-size: 24px;
    color: var(--white-to-black);
    text-align: center;
}

.form-row {
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.blur {
    -webkit-filter: blur(8px);
    -moz-filter: blur(8px);
    -o-filter: blur(8px);
    -ms-filter: blur(8px);
    filter: blur(8px);
}

.pointer {
    cursor: pointer;
}

.quote-block {
    background: var(--background-dark-mid);
    padding: 20px;
    width: 100%;
    line-height: 1.8;
    color: var(--white-to-black);
}

.table-cont {
    width: 100%;
    overflow-x: scroll;
}

table.cabinet {
    width: 100%;
}

.cabinet th {
    background: var(--fs-th);
    color: var(--white-to-black);
    padding: 8px;
    text-align: center;
}

.cabinet td {
    color: var(--white-to-black);
    font-size: 1.1em;
    font-weight: 400;
    border-bottom: 1px solid var(--border);
}

.cabinet td, th {
    text-align: center;
    border-right: 1px solid transparent;
    padding: 8px 20px;
}

.cabinet.fs td {
    font-weight: 300;
    border: none;
}

.cabinet.fs .th {
    border: none;
}

.widget .title {
    padding: 20px 10px 10px 20px;
    color: var(--white-to-black);
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.3em;
}

.widget .title i {
    font-size: 20px;
    cursor: pointer;
}

.widget.item {
    display: flex;
    flex: 1 1 1px;
    margin-bottom: 5px;
    background: var(--background-dark);
    flex-direction: column;
    overflow: hidden;
    border-bottom: 1px solid var(--border);
}

.widget .content {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    padding: 0 10px;
}

.card-bg {
    border-radius: 10px;
    padding: 20px;
    background: var(--background-dark-mid);
}

.card-bg.activeLog {
    min-height: 200px;
}

/*--------------*/

.row.fs {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}

.col.fs {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.3vw;
}

input.fs, select.fs {
    border-radius: .4vw;
    background: var(--background-dark-mid);
    border: 1px solid var(--fs-border);
    position: relative;
}

select.fs {
    background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%);
    background-position: calc(100% - 20px) calc(1em + 2px),
    calc(100% - 15px) calc(1em + 2px),
    calc(100% - 2.5em) 0.5em;
    background-size: 5px 5px,
    5px 5px,
    1px 1.5em;
    background-repeat: no-repeat;
}

select.fs.activeSelect {
    background-position: calc(100% - 15px) 1em,
    calc(100% - 20px) 1em,
    calc(100% - 2.5em) 0.5em;
    background-size: 5px 5px,
    5px 5px,
    1px 1.5em;
    background-repeat: no-repeat;
    outline: 0;
}

button.fs {
    width: 100%;
}

table.fs {
    border-collapse: collapse;
}

button.fs,
button.fs-small,
button.fs-normal {
    background: var(--green);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 5px;
}

tr.fs {
    /*background-color: var(--background);*/
}

tr.fs:nth-child(even) {
    background-color: var(--background-dark-mid);
}

thead .fs {
    /*background-color: var(--background);*/
}

tr.fs {
    /*border-top: 5px solid black;*/
}

th.fs {
    /*border-right: 10px solid black;*/
}

.fullscreen-page-sub-title {
    color: var(--white-to-black);
    font-size: 18px;
    font-weight: 400;
    padding: 0;
}

.form-control.fs {
    padding-right: 20px;
}
.switch {
    background-color:#d9d9d9;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    user-select: none;
    width: 60px;
    margin: 0 40px 0 auto;
    cursor: pointer;
}

aside .switch{
    margin: 0 auto 10px;
}

.switch:after{
    content: '';
    width: 30px;
    height: 30px;
    position: absolute;
    top: 50%;
    left: 0;
    border-radius: 5px;
    transform: translateY(-50%);
    background-color: #4b5d6a;
    transition: all .3s ease;
}
.switch.active:after{
    left: 30px;
}
.switch.active div:first-child svg path{
    transition: all .3s ease;
    fill: #258BD4
}
.switch.active div:nth-child(2) svg path{
    transition: all .3s ease;
    fill: #fff
}
.switch div{
    z-index: 8888;
    position: relative;
    border-radius: 5px;
    padding: 6.2px;
    display: flex;
    align-items: center;
}
.switch input{
    width: 20px;
    height: 20px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0;
    cursor: pointer;
}

.v-popper--theme-tooltip .v-popper__inner{
    background: var(--background-dark);
    color: var(--font);
    border-radius:4px;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.4px;
    max-width: 250px;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3);
  }

.v-popper--theme-tooltip .v-popper__inner .tooltip-title{
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.1px;
}

.v-popper__arrow-container{
    display: none;
}

@media (min-width: 1000px) {
    .card-bg {
        border-radius: .5vw;
        padding: 1vw;
    }

    .quote-block {
        padding: 1vw;
        font-size: 1vw;
    }

    .cabinet th.fs {
        padding: .7vw 0;
        font-size: 1vw;
    }

    tr.fs {
        font-size: .8vw;
        /*border-top: .4vw solid black;*/
    }

    th.fs {
        /*border-right: .6vw solid black;*/
    }

    .cabinet td {
        font-size: 1vw;
    }

    .cabinet td, th {
        text-align: center;
        border-right: 1px solid transparent;
        padding: .4vw 1vw;
    }

    select.fs {
        background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%);
        background-position: calc(100% - 1.7vw) 1vw, calc(100% - 1.35vw) 1vw, calc(100% - 3vw) 0.4vw;
        background-size: .4vw .4vw, .4vw .4vw, .1vw .5vw;
        background-repeat: no-repeat;
        border: 0.1vw solid rgba(255, 255, 255, 0.3);
    }

    select.fs.activeSelect {
        background-image: linear-gradient(45deg, gray 50%, transparent 50%),
        linear-gradient(135deg, transparent 50%, gray 50%);
        background-position: calc(100% - 1.35vw) 1vw, calc(100% - 1.7vw) 1vw, calc(100% - 3vw) 0.4vw;
        background-size: .4vw .4vw, .4vw .4vw, .1vw .5vw;
        background-repeat: no-repeat;
        outline: 0;
    }


    .form-control.fs {
        color: var(--white-to-black);
        padding: .4vw .625vw;
        font-size: 1.1vw;
        height: 2.55vw;
        border-radius: .5vw;
        margin-left: 0px;
    }

    .form-row.fs {
        margin-bottom: 1vw;
    }

    .form-title {
        font-size: 1vw;
        margin-bottom: .5vw;
        margin-top: 1vw;
    }

    .form-row:first-child .form-title {
        margin-top: 0;
    }

    .fullscreen-page-title {
        font-size: 1.5vw;
        padding: 0 0 2vw 0;
    }

    .fullscreen-page-sub-title {
        font-size: 1vw;
    }

    input.fs {
        font-size: 1vw;
        padding: .5vw .8vw;
        border-radius: .5vw;
        border: .1vw solid var(--background-footer);
    }

    label.fs {
        font-size: 1vw;
        margin-bottom: .5vw;
    }

    button.fs {
        font-size: 1.2vw;
        width: 100%;
        padding: .4vw 1vw;
        border-radius: .4vw;
    }

    button.fs,
    button.fs-small,
    button.fs-normal {
        border: .1vw solid rgba(255, 255, 255, 0.3);
        padding: 0 .5vw;
    }

    button.fs-small {
        font-size: 1vw;
        padding: .1vw 1vw;
        border-radius: .3vw;
    }

    button.fs-normal {
        font-size: 1vw;
        height: 2.55vw;
        border-radius: .3vw;
    }


}

/*--------------*/
@media (max-width: 1000px) {
    th.fs {
        border-right: none;
    }

    .col.fs {
        grid-template-columns: 1fr;
        margin-bottom: 20px;
    }

    .row {
        margin-bottom: 10px;
    }

    select.fs {
        background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%);
        background-position: calc(100% - 15px) calc(1em), calc(100% - 10px) calc(1em), calc(100% - 2.5em) 0.5em;
        background-size: 5px 5px, 5px 5px, 1px 1.5em;
        background-repeat: no-repeat;
    }

    select.fs.activeSelect {
        background-image: linear-gradient(45deg, gray 50%, transparent 50%),
        linear-gradient(135deg, transparent 50%, gray 50%);
        background-position: calc(100% - 10px) 1em, calc(100% - 15px) 1em, calc(100% - 2.5em) 0.5em;
        background-size: 5px 5px,
        5px 5px,
        1px 1.5em;
        background-repeat: no-repeat;
        border-color: gray;
        outline: 0;
    }
}

@media (max-width: 1023px) {
    html, body {
        overflow: hidden;
    }

    .nomobile {
        display: none !important;
    }

    .blur-container {
        overflow: hidden;
    }
}


@media (max-width: 1000px) {

    .form-row {
        margin-bottom: 15px;
    }

    input.fs, select.fs {
        border-radius: 10px;
    }

    .fullscreen-page-title {
        padding-bottom: 40px;
    }
}

/*--------------*/

.main {
    display: flex;
    align-items: stretch;
    flex: 1 1 auto;
    background-size: contain;
    position: relative;
}

.bigPane {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

</style>
